module.exports = __webpack_public_path__ + "media/images/flags/32/Zambia-c50a9cf0306220dc8148c215a4fb1471.png";